import { Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'

interface Props {
  name: string
  ruleType: 'global' | 'carrierVisit'
}

export const IssueCardRuleInfo = ({ name, ruleType }: Props) => {
  const { t } = useTranslate()
  return (
    <>
      <Typography variant='body2'>{name}</Typography>
      <Typography variant='caption'>
        {ruleType === 'global'
          ? t('globalRule', 'Global rule')
          : t('carrierVisitRule', 'Carrier visit rule')}
      </Typography>
    </>
  )
}
